import queryString from 'query-string'
import routeParams from 'helpers/routeParams'

const GET_PAYMENTS = 'dofe-bo/payments/GET_PAYMENTS'
const GET_PAYMENTS_SUCCESS = 'dofe-bo/payments/GET_PAYMENTS_SUCCESS'
const GET_PAYMENTS_FAIL = 'dofe-bo/payments/GET_PAYMENTS_FAIL'

const GET_PAYMENTS_WAITING_SUCCESS =
  'dofe-bo/payments/GET_PAYMENTS_WAITING_SUCCESS'

const GET_PAYMENTS_EXPIRED_SUCCESS =
  'dofe-bo/payments/GET_PAYMENTS_EXPIRED_SUCCESS'

const RESET_LINK = 'dofe-bo/payments/RESET_LINK'
const RESET_LINK_SUCCESS = 'dofe-bo/payments/RESET_LINK_SUCCESS'
const RESET_LINK_FAIL = 'dofe-bo/payments/RESET_LINK_FAIL'

const SET_WAITING_PARAMS = 'dofe-bo/payments/SET_WAITING_PARAMS'
const SET_EXPIRED_PARAMS = 'dofe-bo/payments/SET_EXPIRED_PARAMS'
const SET_FILTER = 'dofe-bo/payments/SET_FILTER'
const RESET_FILTERS = 'dofe-bo/payments/RESET_FILTERS'

const initialState = {
  list: [],
  waiting: {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: ''
  },
  expired: {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: ''
  },
  detail: {},
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PAYMENTS:
      return {
        ...state,
        loading: true
      }
    case GET_PAYMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        waiting: {
          ...state.waiting,
          list: action.result.waitingOnlinePayments,
          count: action.headers['x-total-count'],
          pages:
            Math.ceil(
              Number(action.headers['x-total-count']) / state.waiting.limit
            ) || state.waiting.pages
        },
        expired: {
          ...state.expired,
          list: action.result.expiredOnlinePayments,
          count: action.headers['x-total-count'],
          pages:
            Math.ceil(
              Number(action.headers['x-total-count']) / state.expired.limit
            ) || state.expired.pages
        }
      }
    case GET_PAYMENTS_WAITING_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        waiting: {
          ...state.waiting,
          list: action.result,
          count: action.headers['x-total-count'],
          pages:
            Math.ceil(
              Number(action.headers['x-total-count']) / state.waiting.limit
            ) || state.waiting.pages
        }
      }
    case GET_PAYMENTS_EXPIRED_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        expired: {
          ...state.expired,
          list: action.result,
          count: action.headers['x-total-count'],
          pages:
            Math.ceil(
              Number(action.headers['x-total-count']) / state.expired.limit
            ) || state.expired.pages
        }
      }
    case GET_PAYMENTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_FILTER:
      return {
        ...state,
        waiting: {
          ...state.waiting,
          filter: action.filterBy,
          offset: 0
        },
        expired: {
          ...state.expired,
          filter: action.filterBy,
          offset: 0
        }
      }
    case RESET_FILTERS:
      return {
        ...state,
        waiting: {
          ...state.waiting,
          filter: '',
          offset: 0
        },
        expired: {
          ...state.expired,
          filter: '',
          offset: 0
        }
      }
    case SET_WAITING_PARAMS:
      return {
        ...state,
        waiting: {
          ...state.waiting,
          limit:
            action.options.limit !== undefined
              ? action.options.limit
              : state.waiting.limit,
          offset:
            action.options.offset !== undefined
              ? action.options.offset
              : state.waiting.offset,
          filter:
            action.options.filter !== undefined
              ? action.options.filter
              : state.waiting.filter,
          sort:
            action.options.sort !== undefined
              ? action.options.sort
              : state.waiting.sort
        }
      }
    case SET_EXPIRED_PARAMS:
      return {
        ...state,
        expired: {
          ...state.expired,
          limit:
            action.options.limit !== undefined
              ? action.options.limit
              : state.expired.limit,
          offset:
            action.options.offset !== undefined
              ? action.options.offset
              : state.expired.offset,
          filter:
            action.options.filter !== undefined
              ? action.options.filter
              : state.expired.filter,
          sort:
            action.options.sort !== undefined
              ? action.options.sort
              : state.expired.sort
        }
      }
    default:
      return state
  }
}

export function getPayments(params = {}, baseFilter, queryParams) {
  return {
    types: [GET_PAYMENTS, GET_PAYMENTS_SUCCESS, GET_PAYMENTS_FAIL],
    promise: client =>
      client.get(
        `api/award-payments/non-paid-online-payments?with=PARTICIPANT_REGISTRATION&${routeParams(
          params,
          baseFilter
        )}&${queryString.stringify(queryParams)}`
      )
  }
}

export function getPaymentsWaiting(params = {}, baseFilter, queryParams) {
  return {
    types: [GET_PAYMENTS, GET_PAYMENTS_WAITING_SUCCESS, GET_PAYMENTS_FAIL],
    promise: client =>
      client.get(
        `api/award-payments/non-paid-online-payments?with=PARTICIPANT_REGISTRATION&sort=-participantRegistration.createdAt&${routeParams(
          params,
          baseFilter
        )}&${queryString.stringify(queryParams)}`
      )
  }
}

export function getPaymentsExpired(params = {}, baseFilter, queryParams) {
  return {
    types: [GET_PAYMENTS, GET_PAYMENTS_EXPIRED_SUCCESS, GET_PAYMENTS_FAIL],
    promise: client =>
      client.get(
        `api/award-payments/non-paid-online-payments/expired?with=PARTICIPANT_REGISTRATION&${routeParams(
          params,
          baseFilter
        )}&${queryString.stringify(queryParams)}`
      )
  }
}

export function resetPaymentLinkExpiration(id) {
  return {
    types: [RESET_LINK, RESET_LINK_SUCCESS, RESET_LINK_FAIL],
    promise: client =>
      client.post(`api/award-payments/${id}/reset-payment-link-expiration`)
  }
}

export function setPaymentsFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setPaymentsWaitingParams(options) {
  return {
    type: SET_WAITING_PARAMS,
    options
  }
}

export function setPaymentsExpiredParams(options) {
  return {
    type: SET_EXPIRED_PARAMS,
    options
  }
}

export function resetPaymentFilters(options) {
  return {
    type: RESET_FILTERS,
    options
  }
}
